<template>
  <g>
    <path
      fill="none"
      :stroke="props.style.stroke"
      :stroke-width="1.5"
      :d="`M${props.sourceX},${props.sourceY} 
           h 20
           C ${props.sourceX + 100} ${props.sourceY} ${getCenter.x} ${
        getCenter.y
      } 
           ${getCenter.x},${getCenter.y}
           C ${getCenter.x} ${getCenter.y}  ${props.targetX - 100} ${
        props.targetY
      } 
           ${props.targetX - 20} ${props.targetY} 
           h 20`"
    />
    <polygon
      fill="#222"
      stroke="#222"
      :points="`${props.targetX},${props.targetY} ${props.targetX - 10},${
        props.targetY - 4
      } ${props.targetX - 10},${props.targetY + 4}`"
    />
    <g
      pointer-events="visibleFill"
      @mousedown="drag"
      @mousemove="move"
      :style="cursor"
    >
      <text
        :x="getCenter.x + 5"
        :y="getCenter.y"
        class="disable-select label"
        stroke="#222"
        :stroke-width="0.2"
      >
        {{ props.label }}
      </text>
    </g>
  </g>
</template>

<script lang="ts" setup>
import { reactive, isReactive, computed, ref } from "vue";
import { EdgeProps, getEdgeCenter } from "@braks/vue-flow";
interface CustomConnectionLineProps extends EdgeProps {
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
  id: string;
  label: string;
  style: object;
}
const props = defineProps<CustomConnectionLineProps>();

let dragOffsetX = ref(null);
let dragOffsetY = ref(null);
let isDragging = ref(false);

const cursor = computed(
  () => `cursor: ${isDragging.value ? "grabbing" : "grab"}`
);

const getCenterFromNodes = computed(() =>
  getEdgeCenter({
    sourceX: props.sourceX,
    sourceY: props.sourceY,
    targetX: props.targetX,
    targetY: props.targetY,
  })
);
const getCenterFromDrag = reactive({ x: 0.0, y: 0.0 });
const getCenter = computed(function () {
  const center = {
    x: getCenterFromNodes.value[0] + getCenterFromDrag.x,
    y: getCenterFromNodes.value[1] + getCenterFromDrag.y,
  };
  // console.log("center", center);
  return center;
});

const drag = (e) => {
  // console.log("onmousedown label ");
  // e.target.style.fill = "#f00";
  dragOffsetX.value = e.offsetX;
  dragOffsetY.value = e.offsetY;
  isDragging.value = true;
  window.addEventListener("mouseup", drop);
};

const move = (e) => {
  if (isDragging.value === true) {
    // console.log("move label");
    // e.target.style.fill = "#00f";
    const transform = JSON.parse(
      "[" +
        getComputedStyle(document.querySelectorAll("g")[0])
          .transform.replace("matrix(", "")
          .replace(")", "") +
        "]"
    );
    getCenterFromDrag.x += (e.offsetX - dragOffsetX.value) * transform[0];
    getCenterFromDrag.y += (e.offsetY - dragOffsetY.value) * transform[0];
  }
};

const drop = (e) => {
  if (isDragging.value === true) {
    // console.log("drop label");
    // square.value.style.fill = "#0f0";
    isDragging.value = false;
    window.removeEventListener("mouseup", drop);
  }
};
</script>

<style scoped>
.disable-select {
  user-select: none; /* supported by Chrome and Opera */
}

.label {
  font: italic 15px sans-serif;
  padding: 3px;
}
</style>
